<template lang="pug">
.container-page
  .title-content(v-if=" showH !== 'false' ")
    .title-center(v-if="titleCenter") {{title}}
    .title(v-else)
      label {{title}}
      img.img(v-if="titleBg" src="../../assets/notification_title_bg.png", alt="")
  .content
    slot
  el-button.footer.todoBtn(v-if="showMore", @click="getMore")
    span {{footer}}
    i.el-icon-arrow-down

</template>

<script>
export default {
  name: 'Container',
  props: {
    showMore: {
      type: Boolean,
      default: false,
    },
    showH: {
      type: String,
      default: 'true',
    },
    minH: {
      type: String,
      default: '400px',
    },
    titleCenter: {
      type: Boolean,
      default: false,
    },
    titleBg: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '容器标题',
    },
    footer: {
      type: String,
      default: '查看更多',
    },
  },
  methods: {
    getMore() {
      this.$emit('getMore');
    },
  },
};
</script>

<style lang="stylus" scoped>
.container-page
  border 1px solid #E3E3E3
  border-radius 8px
  .content
    width 100%
    border 1px
    border-bottom-left-radius 8px
    border-bottom-right-radius 8px
    background #fff
    border-top 1px solid #E3E3E3
  .title, .title-center
    border 1px
    border-top-left-radius 8px
    border-top-right-radius 8px
    background #F7F7F7
    width 100%
    display flex
    min-height 50px
    flex-direction column
    justify-content center
    .img
      padding 0 20px 20px 20px
    label
      height 50px
      line-height 50px
      display inline-block
    // line-height 50px
  .footer
    width 100%
    border-radius 0
  .title
    label
      padding-left 20px
  .title-center
    text-align center
  .footer
    text-align center
    i
      padding-left 4px
</style>



// WEBPACK FOOTER //
// Container.vue?6f50035a